import { FetcherWithComponents } from "@remix-run/react";

// https://github.com/remix-run/remix/discussions/2749#discussioncomment-6198996
// This is used to clear 'fetcher.data' manually if needed
export const action = () => {
  return null;
}

export const resetFetcher = (fetcher: FetcherWithComponents<any>) => {
  fetcher.submit({}, { action: "/reset/fetcher", method: "post" });
};
